import React, { useEffect, useState } from "react";
import { Getpatientlaborder } from "../../../api/helper";
import { useSelector } from "react-redux";

const DetailsLabsPatient = () => {
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [data, setdata] = useState([]);
  const profiledata = useSelector((state) => state?.cookies?.userDetails);

  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };
  const Getdata = async () => {
    try {
      const respo = await Getpatientlaborder(profiledata?._id);
      setdata(respo?.data?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    Getdata();
  }, []);
  console.log(data, "data=-=");
  return (
    <div className="patient_right">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          alignSelf: "flex-end",
          marginTop: 20,
          marginRight: 20,
        }}
        onClick={toggleFormVisibility}
      >
        <img src={require("../../assest/Images/ViewPrescriptions.png")} />
        <div className="view_Prescriptions_txt">View Orders</div>
      </div>
      <div className="medication-table-container">
        {data && data.length > 0 ? (
          <table className="medication-table">
            <thead>
              <tr>
                <th>Diagnoses</th>
                <th>Labs</th>
                <th>Notes to Office Staff</th>
                <th>Ordering Provider</th>
                <th>Processing Responsible</th>
                <th>Stat</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={item._id || index}>
                  <td>{item.DiagnosisId?.sortDescription || "N/A"}</td>
                  <td>{item.sampleLabId?.name || "N/A"}</td>
                  <td>{item.NotesToOfficeStaff || "-"}</td>
                  <td>
                    {item.OrderingProvider
                      ? `${item.OrderingProvider.firstName} ${item.OrderingProvider.lastName}`
                      : "N/A"}
                  </td>
                  <td>
                    {item.ResponsibleForProcessing
                      ? `${item.ResponsibleForProcessing.firstName} ${item.ResponsibleForProcessing.lastName}`
                      : "N/A"}
                  </td>
                  <td>{item.Stat ? "Yes" : "No"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="medication-empty-state">
            <div className="medication-empty-title">Nothing Here Yet</div>
            <div className="medication-empty-description">
              No health records available for this resource
            </div>
          </div>
        )}
      </div>

      {isFormVisible && (
        <div className="add_problem_div1">
          <div className="Add_problem_txtt1">
            Orders
            {/* Close Icon */}
            <img
              src={require("../../assest/Images/crossIconn.png")}
              alt="close"
              onClick={toggleFormVisibility} // Hides form when clicked
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="div_Draft_txt">
            <p className="Draft_Order_txt">Draft Orders</p>
          </div>
          <div className="div_Draft_txt">
            <p className="Draft_Order_txt">Result Pending</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailsLabsPatient;
